import React from 'react';
import Loadable from 'react-loadable';

function withLoadable(component) {
    return Loadable({
        loader: component,
        loading: () => (
            <div />
            //<div className={`loading`}></div>
        )
    });
}

/**
 *
 * @param {() => Promise} fn 需要重试执行的函数
 * @param {number} retriesLeft 剩余重试次数
 * @param {number} interval 间隔重试请求时间，单位ms
 * @returns Promise<any>
 */
const retryLoad = (fn, retriesLeft = 5, interval = 1000) => {
    return new Promise((resolve, reject) => {
        fn()
            .then(resolve)
            .catch(err => {
                setTimeout(() => {
                    if (retriesLeft === 1) {
                        // 远程上报错误日志代码
                        reject(err);
                        // coding...
                        console.log(err);
                        return;
                    }
                    retryLoad(fn, retriesLeft - 1, interval).then(resolve, reject);
                }, interval);
            });
    });
};

let router = [
    {
        name: '/',
        path: '/',
        exact: true,
        component: withLoadable(() => import('containers/login'))
    },
    {
        name: 'RechargeGold',
        path: '/recharge_gold',
        exact: true,
        component: withLoadable(() => import('containers/pay/pay.all'))
    },
    {
        name: 'Earn',
        path: '/earn',
        exact: true,
        component: withLoadable(() => import('containers/earn/index'))
    },
    {
        name: 'EarnReview',
        path: '/invite',
        exact: true,
        component: withLoadable(() => import('containers/earn/index_review'))
    },
    {
        name: 'EarnExchange',
        path: '/earn_exchange',
        exact: true,
        component: withLoadable(() => import('containers/earn/earn_exchange'))
    },
    {
        name: 'EarnAlertV2',
        path: '/earn_alert_v2',
        exact: true,
        component: withLoadable(() => import('containers/earn/alert_v2'))
    },
    {
        name: 'login',
        path: '/login',
        exact: true,
        component: withLoadable(() => import('containers/login'))
    },
    {
        name: 'loginVerify',
        path: '/login_verify',
        exact: true,
        component: withLoadable(() => import('containers/login/login.verify'))
    },
    {
        name: 'Download',
        path: '/download',
        exact: true,
        component: withLoadable(() => import('containers/download'))
    },
    {
        name: 'Wallet',
        path: '/wallet',
        exact: true,
        component: withLoadable(() => import('containers/wallet'))
    },
    {
        name: 'signInWebView',
        path: '/sign-in-wv',
        exact: true,
        component: withLoadable(() => import('containers/signIn/index_1'))
    },
    {
        name: 'Greet',
        path: '/greet',
        exact: true,
        component: withLoadable(() => import('containers/greet'))
    },
    {
        name: 'Alipay',
        path: '/alipay',
        exact: true,
        component: withLoadable(() => import('containers/alipay'))
    },
    {
        name: 'TransformDiamond',
        path: '/transform_diamond',
        exact: true,
        component: withLoadable(() => import('containers/transformDiamond'))
    },
    {
        name: 'TransformGold',
        path: '/transform_gold',
        exact: true,
        component: withLoadable(() => import('containers/transformGold'))
    },
    {
        name: 'EarnDetail',
        path: '/earn_detail',
        exact: true,
        component: withLoadable(() => import('containers/earnDetail'))
    },
    {
        name: 'Pay',
        path: '/pay',
        exact: true,
        component: withLoadable(() => import('containers/pay/pay.all'))
    },
    {
        // 公会帮助
        name: 'FamilyHelp',
        path: '/family_help',
        exact: true,
        component: withLoadable(() => import('containers/familyHelp'))
    },
    {
        // 公会流水
        name: 'FamilyFlow',
        path: '/family_flow',
        exact: true,
        component: withLoadable(() => import('containers/familyFlow'))
    },
    {
        // 公会成员管理
        name: 'FamilyActors',
        path: '/family_actors',
        exact: true,
        component: withLoadable(() => import('containers/familyActors'))
    },
    {
        // 公会流水
        name: 'FamilyRank',
        path: '/family_rank',
        exact: true,
        component: withLoadable(() => import('containers/familyRank'))
    },
    {
        // 周星活动页面
        name: 'Star',
        path: '/star',
        exact: true,
        component: withLoadable(() => import('containers/star'))
    },
    {
        // 周星结果页面
        name: 'StarResult',
        path: '/star_result',
        exact: true,
        component: withLoadable(() => import('containers/star/result'))
    },
    {
        // 周星结果页面
        name: 'StarEnding',
        path: '/star_ending',
        exact: true,
        component: withLoadable(() => import('containers/star/ending'))
    },
    {
        // 周星规则
        name: 'StarRule',
        path: '/star_rule',
        exact: true,
        component: withLoadable(() => import('containers/star/rule'))
    },
    {
        //  福利社
        name: 'Welfare',
        path: '/welfare',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        //  福利社1103
        name: 'Welfare_1103',
        path: '/welfare_1103',
        exact: true,
        component: withLoadable(() => import('containers/welfare/index_1103'))
    },
    {
        //  福利社1103
        name: 'WelfareAlert',
        path: '/welfare_alert',
        exact: true,
        component: withLoadable(() => import('containers/welfare/alert'))
    },
    {
        name: 'valentines',
        path: '/valentines',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        name: 'valentinesRain',
        path: '/valentines_rain',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        name: 'VoiceAudit',
        path: '/voice_audit',
        exact: true,
        component: withLoadable(() => import('containers/voiceAudit'))
    },
    {
        name: 'VoiceCheckDetail',
        path: '/voice_check_detail',
        exact: true,
        component: withLoadable(() => import('containers/voiceCheck'))
    },
    {
        name: 'VoiceAuditResult',
        path: '/voice_audit_result',
        exact: true,
        component: withLoadable(() => import('containers/voiceAudit/result'))
    },
    {
        name: 'Test',
        path: '/test',
        exact: true,
        component: withLoadable(() => import('containers/test/center'))
    },
    {
        name: 'GradeV2',
        path: '/grade_v2',
        exact: true,
        component: withLoadable(() => import('containers/grade/index_v3'))
    },
    {
        name: 'GradeV2Review',
        path: '/grade_v2_review',
        exact: true,
        component: withLoadable(() => import('containers/grade/index.v3.review'))
    },
    {
        name: 'Hor',
        path: '/hor',
        exact: true,
        component: withLoadable(() => import('containers/hor/index'))
    },
    {
        name: 'HorBirthGiftAlert',
        path: '/hor_birth_gift_alert',
        exact: true,
        component: withLoadable(() => import('containers/hor/alert'))
    },
    // 七夕
    {
        name: 'Qixi',
        path: '/qixi',
        exact: true,
        component: withLoadable(() => import('containers/qixi/index'))
    },
    // wedding
    {
        name: 'Wedding',
        path: '/wedding',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    // 中秋
    {
        name: 'MidAutumn',
        path: '/mid_autumn',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    // 万圣节
    {
        name: 'halloween',
        path: '/ ',
        exact: true,
        component: withLoadable(() => import('containers/halloweenDay'))
    },
    {
        name: 'DressExchange',
        path: '/dress_exchange',
        exact: true,
        component: withLoadable(() => import('containers/dressExchange'))
    },
    {
        name: 'DressActivity',
        path: '/dress_activity',
        exact: true,
        component: withLoadable(() => import('containers/dress'))
    },
    {
        name: 'Noble',
        path: '/noble',
        exact: true,
        component: withLoadable(() => import('containers/noble/noble_center'))
    },
    {
        name: 'NobleRule',
        path: '/noble_rule',
        exact: true,
        component: withLoadable(() => import('containers/noble/rule'))
    },
    {
        // 新手任务
        name: 'Fish_task',
        path: '/fish_task',
        exact: true,
        component: withLoadable(() => import('containers/fish/fish_task.jsx'))
    },
    {
        // 新手礼包
        name: 'FishPackage',
        path: '/fish_package',
        exact: true,
        component: withLoadable(() => import('containers/fish/fish_package.jsx'))
    },
    {
        // 新手礼包
        name: 'CardToast',
        path: '/card_toast',
        exact: true,
        component: withLoadable(() => import('containers/cardToast/index.jsx'))
    },
    {
        // 版本更新弹窗
        name: 'VersionUpdateTips',
        path: '/version_update_tips',
        exact: true,
        component: withLoadable(() => import('containers/versionUpdateTips/index.jsx'))
    },
    {
        // 充值放价弹窗
        name: 'RechargeActivityAlert',
        path: '/recharge_activity_alert',
        exact: true,
        component: withLoadable(() => import('containers/rechargeActivityAlert/index.jsx'))
    },
    {
        // 2022国庆节
        name: 'NationalDay',
        path: '/national_day',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        // 今日缘分弹窗
        name: 'TodayFate',
        path: '/today_fate',
        exact: true,
        component: withLoadable(() => import('containers/todayFate/alert.jsx'))
    },
    {
        // 任务中心
        name: 'MissionCenter',
        path: '/mission_center',
        exact: true,
        component: withLoadable(() => import('containers/missionCenter/index.jsx'))
    },
    {
        // 花选ios审核 任务中心
        name: 'MissionCenterReview',
        path: '/mission_center_review',
        exact: true,
        component: withLoadable(() => import('containers/missionCenter/index.review.jsx'))
    },
    {
        //
        name: 'LuckyLots',
        path: '/lucky_lots',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        // 女生节
        name: 'GirlsDay',
        path: '/girls_day',
        exact: true,
        component: withLoadable(() => import('containers/girlsDay/Girls'))
    },
    {
        // 女生节
        name: 'GirlsDay1',
        path: '/girls_day1',
        exact: true,
        component: withLoadable(() => import('containers/girlsDay/2025/index'))
    },
    {
        // 女生节
        name: 'ChildrenDay',
        path: '/children_day',
        exact: true,
        component: withLoadable(() => import('containers/childrenDay'))
    },
    {
        // 端午节
        name: 'DragonBoat',
        path: '/dragon_boat',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        // 花神
        name: 'FlowerGodV2',
        path: '/flower_god_v2',
        exact: true,
        component: withLoadable(() => import('containers/flowerGod/index_v2'))
    },
    {
        // 注销
        name: 'Deactivate',
        path: '/deactivate',
        exact: true,
        component: withLoadable(() => import('containers/deactivate/index'))
    },
    // 发布需求
    {
        name: 'Requirements',
        path: '/requirements',
        exact: true,
        component: withLoadable(() => import('containers/requirements'))
    },
    // 亚运会
    {
        name: 'Olympics',
        path: '/olympics',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    // 声恋告白
    {
        name: 'VoiceSayLove',
        path: '/voice_say_love',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        name: 'ChristmasDay',
        path: '/christmas_day',
        exact: true,
        component: withLoadable(() => import('@/containers/activityEnd'))
    },
    // 扫码
    {
        name: 'ScanCode',
        path: '/scan_code',
        exact: true,
        component: withLoadable(() => import('containers/verify/scanCode'))
    },
    // 模拟器实名认证
    {
        name: 'Verify',
        path: '/verify',
        exact: true,
        component: withLoadable(() => import('containers/verify'))
    },
    // 元旦
    {
        name: 'NewYearDay',
        path: '/new_year_day',
        exact: true,
        component: withLoadable(() => import('containers/activity/NewYears'))
    },
    {
        name: 'NewYearHistory',
        path: '/new_year_history',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        name: 'SpringFestival',
        path: '/spring_festival',
        exact: true,
        component: withLoadable(() => import('containers/spring/index'))
    },
    {
        // 灵宠秘境
        name: 'SpringFestivalFriend',
        path: '/spring_festival_friend',
        exact: true,
        component: withLoadable(() => import('containers/spring/friend'))
    },
    {
        // 灵宠秘境
        name: 'SpringFestivalHeartBeatAlert',
        path: '/spring_festival_heart_beat_alert',
        exact: true,
        component: withLoadable(() => import('containers/spring/alert'))
    },
    {
        name: 'DragonGift',
        path: '/dragon_gift',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        name: 'Pub',
        path: '/pub',
        exact: true,
        component: withLoadable(() => import('containers/pub/index'))
    },
    {
        name: 'FoolsDay',
        path: '/fools_day',
        exact: true,
        component: withLoadable(() => import('containers/foolsDay/index'))
    },
    {
        name: 'SpringGift',
        path: '/spring_gift',
        exact: true,
        component: withLoadable(() => import('@/containers/seasonGift/SeasonGiftLayout'))
    },
    {
        name: 'SeasonGift',
        path: '/season_gift',
        exact: true,
        component: withLoadable(() => import('@/containers/seasonGift'))
    },
    {
        name: 'SeasonGiftAlert',
        path: '/season_gift_alert',
        exact: true,
        component: withLoadable(() => import('@/containers/seasonGift/alert'))
    },
    {
        name: 'FemaleRookieTask',
        path: '/female_rookie_task',
        exact: true,
        component: withLoadable(() => import('containers/missionCenter/female_rookie_task'))
    },
    {
        name: 'FemaleRookieTaskAlert',
        path: '/female_rookie_task_alert',
        exact: true,
        component: withLoadable(() => import('containers/missionCenter/female_rookie_task_alert'))
    },
    {
        name: 'MayDay',
        path: '/may_day',
        exact: true,
        component: withLoadable(() => import('@/containers/mayday'))
    },
    {
        // 五一好友餐厅
        name: 'MayDayFriend',
        path: '/may_day_friend',
        exact: true,
        component: withLoadable(() => import('@/containers/mayday/otherRestaurant'))
    },
    {
        name: 'PayBak',
        path: '/hx_pay',
        exact: true,
        // component: withLoadable(() => import('containers/pay/pay.hx')),
        component: withLoadable(() => import('containers/pay/pay.all'))
    },
    {
        // 520心动榜单活动页
        name: 'Love520',
        path: '/love_520',
        exact: true,
        component: withLoadable(() => import('containers/love520'))
    },
    {
        name: 'VipCenter',
        path: '/vip_center',
        exact: true,
        component: withLoadable(() => import('containers/vipCenter/index'))
    },
    {
        name: 'VipSetting',
        path: '/vip_setting',
        exact: true,
        component: withLoadable(() => import('containers/vipSetting/index'))
    },
    {
        name: 'HelpAlert',
        path: '/help_alert',
        exact: true,
        component: withLoadable(() => import('containers/help/alert'))
    },
    {
        name: 'CloseFriends',
        path: '/close_friends',
        exact: true,
        component: withLoadable(() => import('containers/closeFriends/index'))
    },
    {
        name: 'CustomerSatisficing',
        path: '/customer_satisficing',
        exact: true,
        component: withLoadable(() => import('containers/customerSatisficing/index'))
    },
    {
        // 活动中心
        name: 'Activity',
        path: '/activity_center',
        exact: true,
        component: withLoadable(() => import('containers/activity/index.jsx'))
    },
    {
        // 排行榜
        name: 'Rank',
        path: '/rank',
        exact: true,
        component: withLoadable(() => import('containers/rank'))
    },
    // 年度回忆
    {
        name: 'Remind',
        path: '/remind',
        exact: true,
        component: withLoadable(() => import('containers/remind/remind'))
    },
    {
        name: 'SevenYears',
        path: '/seven_years',
        exact: true,
        component: withLoadable(() => import('containers/activity/7_years'))
    },
    {
        name: 'SevenYearsOutside_page',
        path: '/seven_years_outside_page',
        exact: true,
        component: withLoadable(() => import('containers/activity/7_years_outside'))
    },
    {
        name: 'SevenYearsBagAlert',
        path: '/seven_years_bag_alert',
        exact: true,
        component: withLoadable(() => import('containers/activity/7_years_reward_alert'))
    },
    {
        name: 'SevenYearsFutureAgreement',
        path: '/seven_years_future_agreement',
        exact: true,
        component: withLoadable(() => import('containers/activity/7_years_future'))
    },
    {
        name: 'FinalistEnd',
        path: '/finalist_end',
        exact: true,
        component: withLoadable(() => import('containers/ceremony/finalist.end'))
    },
    {
        name: 'FinalistMiddleRegister',
        path: '/finalist_middle_register',
        exact: true,
        component: withLoadable(() => import('containers/ceremony/finalist.middle.register'))
    },
    {
        name: 'FinalistMiddleSchedule',
        path: '/finalist_middle_schedule',
        exact: true,
        component: withLoadable(() => import('containers/ceremony/finalist.middle.register'))
    },
    {
        name: 'Rain',
        path: '/rain',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        name: 'LanternFestival',
        path: '/lantern_festival',
        exact: true,
        component: withLoadable(() => import('containers/activity/LanternFestival'))
    },
    // 游戏嘉年华
    {
        name: 'GameCarnival',
        path: '/game_carnival',
        exact: true,
        component: withLoadable(() => import('containers/activityEnd'))
    },
    {
        name: 'Relationship',
        path: '/relationship',
        exact: true,
        component: withLoadable(() => import('containers/relationship'))
    },
    {
        name: 'CancelRelationship',
        path: '/cancel_relationship',
        exact: true,
        component: withLoadable(() => import('containers/relationship/cancel'))
    },
    {
        name: 'RelationshipIntro',
        path: '/relationship_intro',
        exact: true,
        component: withLoadable(() => import('containers/relationship/relationship_intro'))
    },
    {
        name: 'SingerApplication',
        path: '/singer_application',
        exact: true,
        component: withLoadable(() => import('containers/ceremony/singer.application'))
    },
    {
        name: 'AppealList',
        path: '/appeal_list',
        exact: true,
        component: withLoadable(() => import('@/containers/appeal/list'))
    },
    {
        name: 'AppealDetail',
        path: '/appeal_detail',
        exact: true,
        component: withLoadable(() => import('@/containers/appeal/detail'))
    },
    {
        name: 'AppealApplication',
        path: '/appeal_application',
        exact: true,
        component: withLoadable(() => import('@/containers/appeal/application'))
    },
    {
        name: 'CancelDeactivate',
        path: '/cancel_deactivate',
        exact: true,
        component: withLoadable(() => import('containers/deactivate/cancel'))
    },
    {
        name: 'AppealLetter',
        path: '/appeal_letter',
        exact: true,
        component: withLoadable(() => import('@/containers/appeal/letter'))
    },
    {
        name: 'Questionnaire',
        path: '/questionnaire',
        exact: true,
        component: withLoadable(() => import('@/containers/activity/questionnaire'))
    },
    {
        name: 'TYMJ',
        path: '/tymj',
        exact: true,
        component: withLoadable(() => import('@/containers/activity/tymj'))
    },
    {
        // 通用活动弹窗
        name: 'ActivityAlert',
        path: '/activity_alert',
        exact: true,
        component: withLoadable(() => import('@/containers/alerts/activity_alert'))
    },
    {
        // 用户技能列表
        name: 'SkillOrderList',
        path: '/skill_order_list',
        exact: true,
        component: withLoadable(() => import('containers/skill/orderList/index'))
    },
    {
        // 用户技能评价
        name: 'SkillOrderEvaluate',
        path: '/skill_order_evaluate',
        exact: true,
        component: withLoadable(() => import('containers/skill/evaluate/index'))
    },
    {
        // 用户技能列表弹窗
        name: 'UserSkillListPopup',
        path: '/user_skill_list_popup',
        exact: true,
        component: withLoadable(() => import('containers/skill/userSkillListPopup'))
    },
    {
        // 用户技能详情
        name: 'SkillOrderDetail',
        path: '/skill_order_detail',
        exact: true,
        component: withLoadable(() => import('containers/skill/order/index'))
    },
    {
        // 用户技能申请
        name: 'SkillVerifyCenter',
        path: '/skill_center_init',
        exact: true,
        component: withLoadable(() => import('containers/skill/verify_center/index'))
    },
    {
        // 用户技能申诉
        name: 'SkillOrderAppeal',
        path: '/skill_order_appeal',
        exact: true,
        component: withLoadable(() => import('containers/skill/appeal/index'))
    },
    {
        // 用户技能列表弹窗
        name: 'UserSkillDetailPopup',
        path: '/user_skill_detail_popup',
        exact: true,
        component: withLoadable(() => import('containers/skill/userSkillDetailPopup'))
    },
    {
        // 用户技能列表弹窗
        name: 'MySkillDetail',
        path: '/skill_center_my',
        exact: true,
        component: withLoadable(() => import('containers/skill/mySkillDetail'))
    },
    {
        // 用户技能认证
        name: 'SkillVerifyApply',
        path: '/my_verify_apply',
        exact: true,
        component: withLoadable(() => import('containers/skill/verify/verify'))
    },
    {
        // 用户技能编辑
        name: 'SkillVerifyEdit',
        path: '/my_verify_edit',
        exact: true,
        component: withLoadable(() => import('containers/skill/verify/edit'))
    },
    {
        // 声音鉴定
        name: 'VoiceAuth',
        path: '/voice_auth',
        exact: true,
        component: withLoadable(() => import('containers/mobile/voice_auth/index'))
    },
    {
        // 新手福利
        name: 'NewUserAward',
        path: '/new_user_award',
        exact: true,
        component: withLoadable(() => import('containers/newUserAward/index'))
    },
    {
        // 处罚通报
        name: 'DisciplinaryNotice',
        path: '/disciplinary_notice',
        exact: true,
        component: withLoadable(() => import('containers/disciplinaryNotice/index'))
    },
    {
        // 三生石
        name: 'Stone',
        path: '/stone',
        exact: true,
        component: withLoadable(() => import('containers/stone'))
    },
    {
        // 三生石
        name: 'HallOfFame',
        path: '/hall_of_fame',
        exact: true,
        component: withLoadable(() => import('containers/hallOfFame/index'))
    },
    {
        // 三生石
        name: 'Boys',
        path: '/boys',
        exact: true,
        component: withLoadable(() => import('@/containers/activityEnd'))
    },
    {
        // 提现3.0
        name: 'WithdrawCenterV3',
        path: '/withdraw_center_v3',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/center'))
    },
    {
        // 提现3.0
        name: 'WithdrawApplyV3',
        path: '/withdraw_apply_v3',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/apply'))
    },
    {
        // 提现3.0
        name: 'WithdrawBlockDiamond',
        path: '/withdraw_block_diamond',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/list/blockDiamond'))
    },
    {
        // 提现3.0
        name: 'WithdrawDiamondList',
        path: '/withdraw_diamond_list',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/list/diamond'))
    },
    {
        // 提现3.0
        name: 'WithdrawListV3',
        path: '/withdraw_list_v3',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/list/list'))
    },
    {
        // 提现3.0
        name: 'WithdrawDetailV3',
        path: '/withdraw_detail_v3',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/list/detail'))
    },
    {
        // 提现3.0
        name: 'WithdrawProtocol',
        path: '/withdraw_protocol',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/protocol/detail'))
    },
    {
        // 提现3.0
        name: 'WithdrawVerify',
        path: '/withdraw_verify',
        exact: true,
        component: withLoadable(() => import('containers/withdrawV3/protocol/verify'))
    },
    {
        // bridge_list
        name: 'bridgeList',
        path: '/bridge_list',
        exact: true,
        component: withLoadable(() => import('containers/test/br'))
    },
    // {
    //     // 提现3.0
    //     name: 'SellGift11',
    //     path: '/sell_gift_11',
    //     exact: true,
    //     component: withLoadable(() => import('containers/activity/sell_gift_11')),
    // },

    // static
    {
        // 提现3.0
        name: 'QingLang',
        path: '/operation_ql',
        exact: true,
        component: withLoadable(() => import('@/containers/static/QingLang'))
    },
    {
        // 谁看过我，我看过谁
        name: 'visit',
        path: '/visit',
        exact: true,
        component: withLoadable(() => import('@/containers/mobile/visit'))
    },
    {
        // 互动列表
        name: 'InteractiveList',
        path: '/interactive_list',
        exact: true,
        component: withLoadable(() => import('@/containers/mobile/interactive'))
    },
    {
        name: 'wx_share_custom',
        path: '/wx_share_custom',
        exact: true,
        component: withLoadable(() => import('@/containers/mobile/share'))
    },
    {
        name: 'ServerAnswer',
        path: '/server_answer',
        exact: true,
        component: withLoadable(() => import('@/containers/mobile/answer'))
    },
    {
        // 挑个好声音
        name: 'SelectVoice',
        path: '/select_voice',
        exact: true,
        component: withLoadable(() => import('@/containers/mobile/select_voice'))
    },
    {
        // 挑个好声音
        name: 'SelectVoiceAlert',
        path: '/select_voice_alert',
        exact: true,
        component: withLoadable(() => import('@/containers/alerts/select_voice_alert'))
    },
    {
        name: 'RescuePrincessRank',
        path: '/rescue_princess_rank',
        exact: true,
        component: withLoadable(() => import('containers/rescuePrincess'))
    }
];

export default router;
